export default {
  SET_USERS_FOR_DEPARTMENT: 'SET_USERS_FOR_DEPARTMENT',
  SET_USERS_FOR_DEPARTMENT_IS_LOADING: 'SET_USERS_FOR_DEPARTMENT_IS_LOADING',
  SET_EDIT_ROLES_FOR_USER: 'SET_EDIT_ROLES_FOR_USER',
  UPDATE_USER_FOR_DEPARTMENT: 'UPDATE_USER_FOR_DEPARTMENT',
};